<template>
  <div v-if="survey" class="d-flex flex-column p-3">
    <b-form-input v-model="survey.name" placeholder="Введите название опроса" @change="saveName" class="mb-3" />
    <lesson-survey-question-tree :isManage="isManage" :surveyId="survey.id" />
  </div>
</template>

<script>
import LessonSurveyQuestionTree from "shared/widgets/tree/course/LessonSurveyQuestionTree.vue";

export default {
  components: { LessonSurveyQuestionTree },
  name: "SurveyBlock",
  props: {
    value: null,
    isManage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      survey: this.value,
      saveTimer: null,
    };
  },
  methods: {
    saveName() {
      if (!this.survey.name) {
        return;
      }

      this.$emit("input", {
        id: this.survey.id,
        name: this.survey.name,
      });
      this.$emit("update");
    },
  },
};
</script>
